import React from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import EmbeddedSymantecSESApp from "./EmbeddedSymantecSESApp";
const SymantecSESApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("symantecses.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("symantecses.app.description"))), /* @__PURE__ */ React.createElement(EmbeddedSymantecSESApp, null));
};
export default SymantecSESApp;
